import { useState, useEffect } from "react";
import { ENE_TAO_TOKEN } from "../constants/index.js";
import { Logo } from "../types/ChatInterfaces";
import { taoCmsClient } from "../API.js";

export const useLogoList = (agencyId: string) => {
  const [logoList, setLogoList] = useState<Logo[]>([]);

  const fetchLogoMap = async () => {
    try {
      const response = await taoCmsClient.get(
        `/tao/api/v2/agencies/${agencyId}/logos`,
        {
          headers: {
            Authorization: `Bearer ${ENE_TAO_TOKEN}`,
          },
        }
      );
      if (response?.status !== 200) {
        throw new Error("Network response was not ok");
      }
      const logos = response?.data?.data || [];
      setLogoList(logos);
    } catch (error) {
      console.log("fetchLogoMap error: " + error);
    } finally {
    }
  };

  useEffect(() => {
    if (agencyId) {
      fetchLogoMap();
    }
  }, []);

  return { logoList };
};
